import React from 'react';
import { capitalize } from 'voca';

import { Message } from 'semantic-ui-react';

import dayjs from 'dayjs';

const icons = {
    error: 'bomb',
    warning: 'exclamation-triangle',
    info: 'info-circle',
    success: 'check-circle'
};

const renderIcon = type => (
    <i aria-hidden='true' className={ `fao fa-${icons[type]} icon` } />
);

const Flash = props => (

    <Message { ...{
        [props.type]: true,
        icon: true,
        size: 'mini',
        onDismiss: () => { props.remove(props.id); }
    }}>
        { renderIcon(props.type) }
        <Message.Content>
            <Message.Header>{capitalize(props.type)}!</Message.Header>
            <small>{ dayjs(props.time).format('HH:mm:ss A')}</small>
            <p>{props.message}</p>
        </Message.Content>
    </Message>
);


export default Flash;
